import React from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import AnnounceListContainer from '../../../features/page/post/announcement/AnnounceListContainer'

interface IProps {
    className?: string
}

const AnnounceListPage: React.FC<IProps> = ({className}) => {
    return (
        <PageLayout title={'Announcements'} className={className}>
            <AnnounceListContainer />
        </PageLayout>
    )
}

export default AnnounceListPage
